import { AssignmentItem } from "./AssignmentItem";

export abstract class Assignment
{
    private id:number;
    private dateAssigned:Date;
    private dateCompleted:Date;
    private type:"Assessment"|"AssessmentGroup"|"LibraryAsset";
    private items:AssignmentItem[];
    
    public constructor() {
        this.dateAssigned = null;
        this.type = "Assessment";
        this.items = [];
    }

    public get Id() : number {
        return this.id;
    }

    public set Id(v:number) {
        this.id = v;
    }
    
    public abstract get Name();
    
    public abstract set Name(v : string);
    
    
    public get DateAssigned() : Date {
        return this.dateAssigned;
    }
    
    public set DateAssigned(v : Date) {
        this.dateAssigned = v;
    }

    public get DateCompleted() : Date {
        return this.dateCompleted;
    }
    
    public set DateCompleted(v : Date) {
        this.dateCompleted = v;
    }
    
    public setDateAssigned(time:number) : Date {
        this.DateAssigned = new Date(time);
        return this.DateAssigned;
    }
    
    
    public get IsComplete() : boolean {
        return this.dateCompleted != null;
    }

    public get Type() : "Assessment"|"AssessmentGroup"|"LibraryAsset" {
        return this.type;
    }

    public set Type(v:"Assessment"|"AssessmentGroup"|"LibraryAsset") {
        this.type = v;
    }

    public get Items() : AssignmentItem[] {
        return this.items;
    }

    public set Items(v:AssignmentItem[]) {
        v = v || []; // make sure we always get an array here

        this.items = v;
    }

    public hasItem(v:AssignmentItem) {
        if (!(v && v.Id)) {
            return false;
        }

        if (this.items.find(i => i.Id == v.Id) !== undefined) {
            return true;
        }
        return false;
    }

    public getTotalAssignments() {
        return this.items.length;
    }

    public getAssignmentsCompleted() {
        return this.items.filter(i => i.IsComplete).length;
    }

    public get hasStarted() {
        return this.getAssignmentsCompleted() > 0;
    }

    public getNextAssignmentItemToComplete() : AssignmentItem {
        return this.items.find(i => !i.IsComplete);
    }

    public markCompleted(assignment:AssignmentItem) {
        let item = this.items.find(i => i.Id == assignment.Id);
        if (item) {
            item.DateCompleted = new Date();
        }
        if (this.Items.every(i => i.IsComplete)) {
            this.DateCompleted = new Date();
        }
    }

    public getResultIds() {
        return this.Items.filter(i => i.IsComplete).map(i => i.ResultId);
    }
    
    
}


// WEBPACK FOOTER //
// ./src/app/shared/models/Assignment.ts